var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z",
    stroke: "#EAECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9053 22.4392C21.3266 23.7699 19.2787 24.5732 17.0409 24.5732C12.0478 24.5732 8 20.5736 8 15.6399C8 10.7061 12.0478 6.70654 17.0409 6.70654C19.2787 6.70654 21.3266 7.50987 22.9053 8.8406C24.484 7.50987 26.5319 6.70654 28.7697 6.70654C33.7628 6.70654 37.8106 10.7061 37.8106 15.6399C37.8106 20.5736 33.7628 24.5732 28.7697 24.5732C26.5319 24.5732 24.484 23.7699 22.9053 22.4392Z",
    fill: "#ED0006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9053 22.4392C24.8492 20.8006 26.0818 18.3625 26.0818 15.6399C26.0818 12.9173 24.8492 10.4791 22.9053 8.8406C24.484 7.50987 26.5319 6.70654 28.7697 6.70654C33.7628 6.70654 37.8106 10.7061 37.8106 15.6399C37.8106 20.5736 33.7628 24.5732 28.7697 24.5732C26.5319 24.5732 24.484 23.7699 22.9053 22.4392Z",
    fill: "#F9A000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9053 22.4391C24.8492 20.8005 26.0818 18.3624 26.0818 15.6398C26.0818 12.9172 24.8492 10.4791 22.9053 8.84058C20.9614 10.4791 19.7288 12.9172 19.7288 15.6398C19.7288 18.3624 20.9614 20.8005 22.9053 22.4391Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpay);
export default __webpack_public_path__ + "static/media/Bpay.330b74388aab7d065aa60a105f67b30c.svg";
export { ForwardRef as ReactComponent };